import React from "react";
import { useState } from "react";
import "../../styles/find-transfer-form.css";
import { Form, FormGroup } from "reactstrap";
import transferData from "../../assets/data/transferData";

const FindTransfer = () => {
  const transfersNames = transferData.map((transfer) => transfer.transferName);

  const [formData, setFormData] = useState({
    transferName: "",
    phoneNumber: "",
    date: "",
    vehicleType: "",
    price: 0,
  });

  const handleTransferChange = (e) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      transferName: value,
      vehicleType: "",
      price: 0,
    }));
  };

  const handleVehicleTypeChange = (e) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      vehicleType: value,
      price: 0,
    }));

    const selectedTransferData = transferData.find(
      (data) => data.transferName === formData.transferName
    );

    if (selectedTransferData) {
      const selectedVehicleData = selectedTransferData.vehicleTypes.find(
        (vehicle) => vehicle.type === value
      );

      if (selectedVehicleData) {
        setFormData((prevData) => ({
          ...prevData,
          price: selectedVehicleData.price || 0,
        }));
      }
    }
  };

  const generateWhatsAppLink = () => {
    const { date, transferName, phoneNumber } = formData;
    const encodedMessage = `Hello from Sankhu Website: Transfer Name: ${encodeURIComponent(
      transferName
    )} Date: ${encodeURIComponent(date)} 
    Phone Number: ${encodeURIComponent(phoneNumber)}`;
    return `https://wa.me/254750542046?text=${encodedMessage}`;
  };

  return (
    <Form className="form">
      <div className=" d-flex align-items-center justify-content-between flex-wrap">
        <FormGroup className="select__group">
          <select
            name="transferName"
            value={formData.transferName}
            onChange={handleTransferChange}
            required
          >
            <option value="">Pick Up & Drop Off</option>
            {transfersNames.map((transferName, index) => (
              <option key={index} value={transferName}>
                {transferName}
              </option>
            ))}
          </select>
        </FormGroup>

        <FormGroup className="select__group">
          <select
            name="vehicleType"
            value={formData.vehicleType}
            onChange={handleVehicleTypeChange}
            required
          >
            <option value="">Select Vehicle Type</option>
            <option value="Sedan/Saloon(1-3 pax)">Sedan/Saloon(1-3 pax)</option>
            <option value="Mini-Van(1-6 pax)">Mini-Van(1-6 pax)</option>
          </select>
        </FormGroup>

        <FormGroup className="form__group">
          <input
            type="tel"
            placeholder="Phone number"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleTransferChange} // You can adjust this based on your requirements
            required
          />
        </FormGroup>

        <FormGroup className="form__group">
          <input
            type="date"
            placeholder="Journey date"
            name="date"
            value={formData.date}
            onChange={handleTransferChange} // You can adjust this based on your requirements
            required
          />
        </FormGroup>

        <FormGroup className="form__group">
          <a
            href={generateWhatsAppLink()}
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="btn find__car-btn" type="button">
              Book Now
            </button>
          </a>
        </FormGroup>
        <FormGroup
          className="form__group"
            >
          {formData.transferName && formData.vehicleType && (
            <p
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "18px",
                color: "#333",
                marginBottom: 0
              }}
            >
              Price: Ksh {formData.price}
            </p>
          )}
        </FormGroup>
      </div>
    </Form>
  );
};

export default FindTransfer;
